import { Component, Input, OnInit } from '@angular/core';
import { File } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';
import { TopicService } from 'app/services/topic.service';
import { StoryboardService } from 'app/services/storyboard.service';

@Component({
  selector: 'app-file-header',
  templateUrl: './file-header.component.html',
  styleUrls: ['./file-header.component.scss']
})
export class FileHeaderComponent implements OnInit {
  @Input() file: File;
  @Input() parentType: string;
  @Input() parentId: string;

  thumbnailSetConfirmed = false;

  constructor(
    private topicService: TopicService,
    private storyboardService: StoryboardService
  ) { }

  ngOnInit() {}

  get isVideo(): boolean {
    return this.file?.contentType === FileType.Video;
  }

  get canSetThumbnail(): boolean {
    return this.isVideo && !!this.parentType && !!this.parentId;
  }

  setAsThumbnail(): void {
    if (!this.file || !this.parentId) {
      console.warn('FileHeaderComponent: Missing file or parentId for thumbnail update');
      return;
    }

    console.log(`FileHeaderComponent: Attempting to set ${this.file.id} as thumbnail for ${this.parentType} ${this.parentId}`);

    if (this.parentType === 'topic') {
      this.topicService.getById(this.parentId).subscribe({
        next: topic => {
          console.log('FileHeaderComponent: Topic fetched successfully, updating thumbnail ID...');
          (topic as any).thumbnailFileId = this.file.id;
          this.topicService.update(topic).subscribe({
            next: () => console.log('FileHeaderComponent: Topic thumbnail updated successfully on backend'),
            error: err => console.error('FileHeaderComponent: Failed to update topic thumbnail:', err)
          });
        },
        error: err => console.error('FileHeaderComponent: Failed to fetch topic for thumbnail update:', err)
      });
    } else if (this.parentType === 'storyboard') {
      this.storyboardService.getById(this.parentId).subscribe({
        next: storyboard => {
          console.log('FileHeaderComponent: Storyboard fetched successfully, updating thumbnail ID...');
          storyboard.thumbnailFileId = this.file.id;
          this.storyboardService.update(storyboard).subscribe({
            next: () => console.log('FileHeaderComponent: Storyboard thumbnail updated successfully on backend'),
            error: err => console.error('FileHeaderComponent: Failed to update storyboard thumbnail:', err)
          });
        },
        error: err => console.error('FileHeaderComponent: Failed to fetch storyboard for thumbnail update:', err)
      });
    }

    this.thumbnailSetConfirmed = true;
    setTimeout(() => this.thumbnailSetConfirmed = false, 2500);
  }
}
